<div class="input-container">
    <ng-container *ngIf="type === 'price'">
        <span class="price">
            <ng-container *ngIf="_kiosk !== true">
                <input #input
                    class="form-control" 
                    type="number" 
                    [name]="name" 
                    [placeholder]="placeholder" 
                    [value]="value" 
                    [readonly]="readonly" 
                    [disabled]="disabled" 
                    [ngClass]="{ 'disabled': disabled }"
                    (input)="onInput($event)" 
                    (keyup)="onKeyUp($event)" 
                    (focus)="onFocus(true)" 
                    (blur)="onFocus(false)" 
                    role="presentation" 
                    [autocomplete]="autocomplete">
                <div class="label" [ngClass]="{ 'placeholder': (!value && !_focus), 'focus': _focus, 'disabled': disabled }">
                    {{Price}}
                </div>
            </ng-container>
            <ng-container *ngIf="_kiosk === true">  
                <input #input 
                    uppNgkiosk 
                    class="form-control" 
                    data-kioskboard-type="price" 
                    type="text" 
                    [name]="name" 
                    [placeholder]="placeholder" 
                    [value]="_price" 
                    [readonly]="readonly" 
                    [disabled]="disabled" 
                    [ngClass]="{ 'disabled': disabled }"
                    (change)="onKiosk($event)" 
                    (focus)="onFocus(true)" 
                    (blur)="onFocus(false)" 
                    role="presentation" 
                    [autocomplete]="autocomplete">
                <div class="label" [ngClass]="{ 'placeholder': (!value && !_focus), 'focus': _focus, 'disabled': disabled  }">
                    {{Price}}
                </div>
            </ng-container>    
        </span>    
    </ng-container>
    <ng-container *ngIf="type !== 'price'">
        <ng-container *ngIf="_kiosk !== true">
            <input #input 
                class="form-control" 
                [type]="_text" 
                [name]="name" 
                [placeholder]="placeholder" 
                [value]="value" 
                [readonly]="readonly" 
                [disabled]="disabled" 
                [ngClass]="{ 'disabled': disabled }"
                (input)="onInput($event)"             
                (keyup)="onKeyUp($event)" 
                (focus)="onFocus(true)" 
                (blur)="onFocus(false)" 
                role="presentation" 
                [autocomplete]="autocomplete">
        </ng-container>
        <ng-container *ngIf="_kiosk === true">
            <input *ngIf="type === 'number'" #input 
                uppNgkiosk
                class="form-control" 
                data-kioskboard-type="num" 
                type="text" 
                [name]="name" 
                [value]="value" 
                [placeholder]="placeholder" 
                [readonly]="readonly" 
                [disabled]="disabled" 
                [ngClass]="{ 'disabled': disabled }"
                (change)="onKiosk($event)" 
                (focus)="onFocus(true)" 
                (blur)="onFocus(false)" 
                role="presentation" 
                [autocomplete]="autocomplete">
            <input *ngIf="type !== 'number'" #input 
                uppNgkiosk
                class="form-control" 
                data-kioskboard-type="all" 
                data-kioskboard-specialcharacters="true" 
                [type]="_text" 
                [name]="name" 
                [value]="value" 
                [placeholder]="placeholder" 
                [readonly]="readonly" 
                [disabled]="disabled" 
                [ngClass]="{ 'disabled': disabled }"
                (change)="onKiosk($event)" 
                (focus)="onFocus(true)" 
                (blur)="onFocus(false)" 
                role="presentation" 
                [autocomplete]="autocomplete">
        </ng-container>  
    </ng-container>    
    
    <div *ngIf="type === 'password'" class="password-toggle" tabindex="0" (click)="OnShowPassword()" (keydown.enter)="OnShowPassword()" (keydown.space)="OnShowPassword()" role="button" aria-label="Toggle password visibility">
        <ion-icon [hidden]="ShowPassword === true" color="medium" name="eye-outline"></ion-icon>
        <ion-icon [hidden]="ShowPassword !== true" color="medium" name="eye-off-outline" x></ion-icon>
    </div>    
</div>
